export default __webpack_public_path__ + "graphics/get_connected_phones.f97251eb.png";